import DecorationMobx from '@mobx/app/decoration.mobx'
import { toPrice } from '@dt/fe-utils'
import { MC_DISCOUNT_TYPE } from './const'

// 判断会员卡权益
export const checkMCBenifit = (card: any = {}, balance?: number) => {
  const benifitRecharge = card.allowAgainLoad || card.allowCustomizeLoad || balance > 0
  const benifitIntegral = card.isIntegral
  const benifitMealRate = card.discountType === MC_DISCOUNT_TYPE.RATE
  const benifitMealPrice = card.discountType === MC_DISCOUNT_TYPE.PRICE
  const benifitMeal = benifitMealRate || benifitMealPrice
  const benifitMallRate = card.mallDiscountType === MC_DISCOUNT_TYPE.RATE
  const benifitMallPrice = card.mallDiscountType === MC_DISCOUNT_TYPE.PRICE
  const benifitMall = benifitMallRate || benifitMallPrice
  const benifitCoupon = card?.couponPolicys?.length > 0
  return {
    benifitRecharge,
    benifitIntegral,
    benifitMealRate,
    benifitMealPrice,
    benifitMeal,
    benifitMallRate,
    benifitMallPrice,
    benifitMall,
    benifitCoupon,
    benifitNum: [benifitRecharge, benifitIntegral, benifitMeal, benifitMall, benifitCoupon].reduce((prev, benifit) => benifit ? prev + 1 : prev, 0)
  }
}

// 会员昵称
export const getNickName = (nickName?: string) => nickName || DecorationMobx.mktDecorates?.nickName?.text || i18n.t('mkt.member.enterNickname')

// 赠金透出
export const getGiveAmount = (cardInfo: any, giveKey?: string, textKey?: string) => cardInfo[giveKey || 'balanceGive'] !== 0 ? i18n.t(`mkt.member.${textKey || 'includeGiveAmount'}`, { amount: toPrice(cardInfo[giveKey || 'balanceGive']) }) : ''

// 等级卡成长值计算
export const getLevelUpGrowth = (nextLevelGrowth: number, curLevelGrowth: number) => {
  return Math.floor((nextLevelGrowth || 0) - (curLevelGrowth || 0))
}
